import { Component } from '@angular/core';

/** Componente de indicador de carregamento (spinner). */
@Component({
  selector: 'app-loading',
  standalone: true,
  imports: [],
  templateUrl: './loading.component.html',
  styleUrl: './loading.component.scss',
})
export class LoadingComponent {}
